import { useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
    Card, CardContent, CardActions, Typography, TextField, Button, IconButton, InputAdornment, Snackbar, Alert, CircularProgress
} from '@mui/material';
import { Visibility, VisibilityOff } from "@mui/icons-material";


const LoginPage = () => {
    const [mobile, setMobile] = useState('');
    const [otp, setOtp] = useState('');
    const [showOtpField, setShowOtpField] = useState(false);
    const [showOtp, setShowOtp] = useState(false);
    const [message, setMessage] = useState('');
    const [userType, setUserType] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState('info');
    const navigate = useNavigate();
    const { login } = useAuth();
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const loginBtnRef = useRef(null);


    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


    const handleGenerateOtp = async () => {
        if (mobile.length !== 10) {
            setMessage('Please enter a valid 10-digit mobile number.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            return;
        }

        try {
            const response = await fetch(`${API_BASE_URL}?action=mobilevalidate&mobile=${encodeURIComponent(mobile)}`);
            const data = await response.json();

            if (data.status === 'success') {
                // If mobile number is registered, allow OTP generation
                setShowOtpField(true);
                setMessage('');
            } else {
                // If mobile number is not registered, show error message
                setMessage(data.message || 'Mobile number not found. Please register first.');
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
            }
        } catch (error) {
            setMessage('Error checking mobile number. Please try again.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            console.error('Error:', error);
        }
    };






    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setUserType('');
        // Ensure OTP is entered and valid (assuming 6-digit OTP)
        if (otp.length !== 10) {
            setMessage("Please Provide a valid Password");
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            return;
        }


        // Ensure OTP matches Mobile Number
        if (otp !== mobile) {
            setMessage("Password does not matched for the provided mobile number.");
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            return;
        }
        try {
            setIsLoading(true)
            const response = await fetch(`${API_BASE_URL}?action=validate&mobile=${encodeURIComponent(mobile)}&otp=${encodeURIComponent(otp)}`);
            const data = await response.json();


            if (data.status === 'success') {
                const userData = { mobile, role: data.user_type };
                login(userData);

                // Store user details in localStorage6
                localStorage.setItem("user_type", data.user_type);
                localStorage.setItem("first_name", data.first_name);
                // Save user in state and localStorage
                localStorage.setItem("mobile", mobile);
                setIsLoading(false);
                navigate("/landing");
                window.scrollTo(0, 0);
                setMessage(data.message);
                setUserType(data.user_type);
                setSnackbarSeverity('success');
                setSnackbarOpen(true);


                // Clear the input fields
                setMobile('');
                setOtp('');
                setShowOtpField(false);




            } else {
                setIsLoading(false);
                setShowOtpField(false);
                setMessage(data.message || 'Mobile number not found. Please register first.');
                setSnackbarSeverity('error');
                setSnackbarOpen(true);


            }
        } catch (error) {
            setIsLoading(false);
            setShowOtpField(false);
            setMessage('Error checking mobile number. Please try again.');
            console.error('Error:', error);
            setSnackbarSeverity('error');
            setSnackbarOpen(true);

        }
        setSnackbarOpen(true);
    };


    return (
        <div className='bg-[#f8f9e9]' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <Card sx={{ backgroundColor: "#F8F9E9", width: { xs: "95%", sm: "85%", md: 450 }, padding: 2, border: "1px solid #CEC35E",
                boxShadow: 1, boxShadow: 2 }}>
                <CardContent >
                    <Typography variant="h3" sx={{ fontWeight: "600", color: "#2A289C", my: 2, fontSize: "26px", textAlign: "center" }} >
                        Welcome Back!
                    </Typography>

                    <Typography variant="h6" sx={{ fontWeight: "400", color: "#000000", my: 2, fontSize: "18px", textAlign: "center" }}>
                        Glad to have you back! Let’s get you logged in.
                    </Typography>


                    <form onSubmit={handleSubmit}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault(); // Prevents new lines in text fields
                                handleSubmit(e); // Calls the form submission function
                            }
                        }}>
                        <TextField label="Mobile Number" placeholder="Enter your Mobile Number" type="text"
                            variant="outlined"
                            fullWidth
                            size="small"
                            margin="normal"
                            value={mobile}
                            onChange={(e) => setMobile(e.target.value)}
                            inputProps={{ maxLength: 10, pattern: "[0-9]*" }}
                            onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10)}
                            sx={{ mb: 2 }}
                            required
                        />


                        <TextField
                            label="Password"
                            placeholder="Re-enter your Phone Number"
                            type={showOtp ? "text" : "password"}
                            variant="outlined"
                            fullWidth
                            size="small"
                            margin="normal"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            inputProps={{ maxLength: 10 }}
                            onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10)}
                            sx={{ mb: 2 }}
                            required
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                       <IconButton
                                        onClick={(e) => {
                                            e.preventDefault(); 
                                            e.stopPropagation();
                                            setShowOtp(prev => !prev);
                                           
                                        }}
                                        edge="end"
                                        tabIndex={0}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                            e.preventDefault();
                                            e.stopPropagation(); 
                                            setShowOtp(prev => !prev);
                                          
                                            
                                            }
                                        }}
                                        >
                                        {showOtp ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>


                                    </InputAdornment>
                                ),
                            }}

                        />
                        <CardActions style={{ justifyContent: 'center', my: 4 }}>


                            {isLoading ? (
                                <CircularProgress color="success" />
                            ) : (
                                <Button
                                    ref={loginBtnRef}
                                    type="submit"
                                    variant="contained"
                                    sx={{
                                        color: 'white',
                                        background: 'linear-gradient(to left bottom, #B4AB57, #947F49)',
                                    }}
                                    className="text-white py-2 px-4 rounded"
                                    fullWidth
                                >
                                    LOGIN
                                </Button>
                            )}

                        </CardActions>

                    </form>

                    <Typography sx={{ mt: 1, textAlign: "center", fontSize: "14px", color: "#000" }}>
                        Don’t have an account? <a href="/register" style={{ color: "blue", fontWeight: "600", textDecoration: "none" }}>Start with Register</a>
                    </Typography>

                    <Typography sx={{ mt: 4, textAlign: "center", fontSize: "12px", color: "#000" }}>

                        Trouble logging in? <a href="/help" style={{ color: "#000", fontWeight: "600", textDecoration: "none" }}>Get Help.</a>
                    </Typography>





                </CardContent>
            </Card>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={5000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>
                    {message}
                </Alert>
            </Snackbar>



        </div>
    );
};


export default LoginPage;

